import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class MwAppService {
  constructor(
    @Inject(DOCUMENT) private document: any,
    private translateService: TranslateService
  ) {}

  setTheme(colorTheme: string): void {
    // Color theme - Use normal for loop for IE11 compatibility
    for (const className of this.document.body.classList) {
      if (className.startsWith('theme-')) {
        this.document.body.classList.remove(className);
      }
    }

    this.document.body.classList.add(colorTheme);
  }

  changeLanguage(language: string): void {
    const defaultLang = this.translateService.getDefaultLang();
    const languages = this.translateService.getLangs();
    const currentLanguage =
      language || this.translateService.getBrowserLang().toLocaleLowerCase();
    const selectLanguage =
      languages.indexOf(currentLanguage) === -1 ? defaultLang : currentLanguage;
    this.translateService.use(selectLanguage);
  }

  setAvailableLanguages(languages: string[], defaultLanguage: string): void {
    this.translateService.addLangs(languages);
    this.translateService.setDefaultLang(defaultLanguage);
  }
}
